import React from 'react';
import { Helmet } from 'react-helmet';
import './css/globals.css';
import './css/contact.css';
import './css/header.css';
import './css/footer.css';
import './css/page.css';
import './css/water-filter.css';
import Header from './sections/Header';
import Footer from './sections/Footer';
import Banner from './waterfilter/Banner';
import Cta from './sections/Cta';
import Section9 from './sections/Section9';
import TitleDescBoxes from './waterfilter/TitleDescBoxes';
import Section3 from './waterfilter/Section3';
import ProductLeft from './waterfilter/ProductLeft';
import Section5 from './waterfilter/Section5';
import Section6 from './waterfilter/Section6';
import Section7 from './waterfilter/Section7';
import Section8 from './waterfilter/Section8';
import Section9_wf from './waterfilter/Section9_wf';
import VideoCTA from './waterfilter/VideoCTA';
import ContactSection from './sections/Section7';


const WaterFilterPage = () => {

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    'name': 'Imperial PDG',
    'description': 'Professional whole-home and under-sink water filter installation on the Gold Coast. Lifetime warranty, Australian-made systems, licensed plumbers.',
    'url': 'https://imperialpdg.com.au/services/water-filter-installation/',
    'telephone': '1300631226',
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': 'PO Box 4916',
      'addressLocality': 'Gold Coast',
      'addressRegion': 'QLD',
      'postalCode': '4217',
      'addressCountry': 'AU'
    },
    'geo': {
      '@type': 'GeoCoordinates',
      'latitude': -28.01294080513038,
      'longitude': 153.40505834857066
    },
    'openingHoursSpecification': [
      { '@type': 'OpeningHoursSpecification', 'dayOfWeek': ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'], 'opens': '07:00', 'closes': '17:00' }
    ],
    'hasOfferCatalog': {
      '@type': 'OfferCatalog',
      'name': 'Water Filter Systems',
      'itemListElement': [
        {
          '@type': 'Product',
          'name': 'Full Home + Reverse Osmosis System',
          'description': 'Whole-home water filtration paired with a 6-stage reverse osmosis system under the sink, installed by a licensed plumber. Clean water from every tap plus ultra-purified drinking water.'
        },
        {
          '@type': 'Product',
          'name': 'Full Home Water Purifier System',
          'description': 'Whole-home water filtration system installed by a licensed plumber. Removes chlorine, heavy metals, sediment, and contaminants from every tap.'
        },
        {
          '@type': 'Product',
          'name': 'WAA 6-Stage Reverse Osmosis Water Filtration System',
          'description': 'Under-sink 6-stage RO system with mineralisation and alkalisation. Suitable for houses and apartments. Electricity-free design.'
        }
      ]
    }
  };

  const accordionData = [
    {
      title: 'Why is regular plumbing maintenance important?',
      content: 'Regular plumbing maintenance is crucial for ensuring the smooth operation of your plumbing system. It helps prevent minor issues from escalating into major, costly problems, extends the lifespan of your plumbing fixtures, and can improve water efficiency, ultimately saving you money on utility bills.'
    },
    {
      title: 'What does plumbing maintenance include?',
      content: 'Plumbing maintenance can include a variety of services such as leak detection and repair, drain cleaning, inspecting and maintaining water heaters, checking water pressure, inspecting pipes for corrosion or damage, and ensuring all fixtures are functioning properly.'
    },
    {
      title: 'How often should I have my plumbing system checked?',
      content: 'It`s recommended to have a professional plumber inspect your plumbing system at least once a year. However, if you have an older home or have experienced issues in the past, more frequent checks might be necessary.'
    },
    {
      title: 'Can plumbing maintenance help with smelly drains?',
      content: 'Absolutely! Regular maintenance can identify and address the causes of smelly drains, such as clogs or venting issues. Additionally, devices like Gratemates can be installed to prevent sewer smells from rising up through the drains.'
    },
    {
      title: 'What are the signs that I need plumbing maintenance?',
      content: 'Common signs include slow drains, unpleasant odours, water stains on walls or ceilings, unusually high water bills, and inconsistent water pressure. If you notice any of these, it`s time to schedule a maintenance check.'
    },
    {
      title: 'Are emergency plumbing services available in Gold Coast?',
      content: 'Yes, many plumbing services in Gold Coast offer 24/7 emergency responses for urgent plumbing issues that cannot wait for regular maintenance appointments.'
    },
    {
      title: 'Is it worth getting a plumbing maintenance plan?',
      content: 'Yes, a plumbing maintenance plan can be very beneficial. It ensures regular inspections and maintenance work, helping to prevent unexpected breakdowns and potentially saving you money in the long run.'
    },
    {
      title: 'Can plumbing maintenance save me money?',
      content: 'Definitely. By catching and fixing small issues early, you can avoid the expense of major repairs. Additionally, well-maintained plumbing systems are more efficient, reducing water and energy waste.'
    },
    {
      title: 'How do I choose the best plumbing maintenance service in Gold Coast?',
      content: 'Look for services with certified and experienced plumbers, positive customer reviews, comprehensive maintenance plans, and a commitment to customer satisfaction. Also, ensure they offer the specific services you need.'
    },
    {
      title: 'Will plumbing maintenance disrupt my daily routine?',
      content: 'Professional plumbers strive to minimise disruption. Maintenance is usually quick and non-invasive, though the duration can vary depending on the services required.'
    },
  ];
  return (
    <>
      <Helmet>
        <title>Water Filter Installation Gold Coast | Whole-Home & Under-Sink Systems | Imperial PDG</title>
        <meta name="description" content="Get clean, filtered water from every tap. Imperial PDG installs whole-home and under-sink reverse osmosis water filtration systems on the Gold Coast. Lifetime warranty. Licensed plumbers. Get a free, no-obligation quote today." />
        <meta name="keywords" content="water filter installation gold coast, whole home water filter, reverse osmosis system gold coast, under sink water filter, water purifier gold coast, imperial pdg water filter" />
        <link rel="canonical" href="https://imperialpdg.com.au/services/water-filter-installation/" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Water Filter Installation Gold Coast | Imperial PDG" />
        <meta property="og:description" content="Professional whole-home and under-sink water filter installation on the Gold Coast. Lifetime warranty, Australian-made systems, licensed plumbers." />
        <meta property="og:url" content="https://imperialpdg.com.au/services/water-filter-installation/" />
        <meta property="og:site_name" content="Imperial PDG" />
        <meta property="og:image" content="https://imperialpdg.com.au/img/Water-Filter-Installation-Gold-Coast-top-Banner.webp" />
        <meta property="og:locale" content="en_AU" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Water Filter Installation Gold Coast | Imperial PDG" />
        <meta name="twitter:description" content="Professional whole-home and under-sink water filter installation on the Gold Coast. Lifetime warranty. Get a free, no-obligation quote today." />
        <meta name="twitter:image" content="https://imperialpdg.com.au/img/Water-Filter-Installation-Gold-Coast-top-Banner.webp" />

        <script type="application/ld+json">{JSON.stringify(schema)}</script>
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          'itemListElement': [
            { '@type': 'ListItem', 'position': 1, 'name': 'Home', 'item': 'https://imperialpdg.com.au/' },
            { '@type': 'ListItem', 'position': 2, 'name': 'Water Filter Installation', 'item': 'https://imperialpdg.com.au/services/water-filter-installation/' }
          ]
        })}</script>
      </Helmet>
      <div className='waterfilterpage'>
        <Header />
        <Banner 
          backgroundImg={"/img/Water-Filter-Installation-Gold-Coast-top-Banner.webp"}
          backgroundAltText={"Mitch from Imperial PDG holding a toolbox posing outside"}
          title={"<b>Pure Water. <br/>Every Tap. Every day.</b>"}
          subtitle={"Experience the freedom of clean, healthy water for drinking, showering, bathing, cooking, and washing — all from our whole-home filtration system."}
        />
        <Cta />
        <Section9
          videoSrc="/videos/Water-Filter-Installation-Gold-Coast-video-1.mp4"
          videoPoster="/img/Water-Filter-Installation-Gold-Coast-top-Banner.webp"
          imgAlt="Plumber installing a water filter"
          title="Whole-home filtration solutions tailored for Australian homes"
          subtitle="Home Water Filter Installation"
          desc={`<p class='desc'>Whole-home water filtration offers more than just improved taste and clarity; it provides essential protection against a range of contaminants commonly found in tap water, such as chlorine, heavy metals, microplastics, and other impurities. For homeowners, our Full Home Water Refining System or Under Sink Reverse Osmosis System ensures clean, purified water from every tap and outlet, supporting both health and comfort.</p><p class='desc'>For those living in apartments or renting their home, our 6-Stage Reverse Osmosis System offers an ideal solution, delivering exceptional water quality in a compact, convenient design that fits seamlessly under your sink. This versatile option allows renters and apartment residents to enjoy fresh, pure water without permanent installation, providing peace of mind and enhanced water quality no matter where you live.</p>`}
        />
        <ProductLeft />
        <TitleDescBoxes />
        <Section3 />
        <Section5 />
        <Section6 />
        <Section7 />
        <Section8 />
        <Section9_wf />
        <VideoCTA
          videoSrc="/videos/video-cta.mp4"
          desc="Enjoy clean, pure water every day. Schedule your consultation or request more information today!"
        />
        <ContactSection />
        <Footer />
      </div>
    </>

  )
}

export default WaterFilterPage


